// extracted by mini-css-extract-plugin
module.exports = {"main":"ColorsPalette_main__1h48w","selected":"ColorsPalette_selected__1IL2T"};